export const subtitles = {
    "1": {
        "startTime": 1.619,
        "endTime": 7.379,
        "transcript": "Waniw' uum Junior-aam yui three-aarulriit.",
        "translation": "Now, Junior has three children."
    },
    "2": {
        "startTime": 7.379,
        "endTime": 9.269,
        "transcript": "Cama-i-aarnga.",
        "translation": "Greet me with a handshake."
    },
    "3": {
        "startTime": 14.452,
        "endTime": 16.642,
        "transcript": "Ak'anek-lli tangerpaa.",
        "translation": "It's been so long since I've seen you."
    },
    "4": {
        "startTime": 20.035,
        "endTime": 26.655,
        "transcript": "Iluperatek-kiq tayim' tangrruaqallerpetegni qavciunguarniartat.",
        "translation": "By your estimation, how many great-grandchildren would you have?"
    },
    "5": {
        "startTime": 29.964,
        "endTime": 35.404,
        "transcript": "Five-aaruciqut waniwa, five. Five-aat [?].",
        "translation": "There are five now, five. Five [?]."
    },
    "6": {
        "startTime": 36.112,
        "endTime": 40.052,
        "transcript": "Qaku ilait wani piniartat?",
        "translation": "When will some of them [have children]?"
    },
    "7": {
        "startTime": 46.336,
        "endTime": 52.196,
        "transcript": "Qavcirluten tuyuurtellrusit, tuyuni kevgiurellren?",
        "translation": "How old were you when you became a pastor, serve as a pastor?"
    },
    "8": {
        "startTime": 53.159,
        "endTime": 56.369,
        "transcript": "Maavet im' move-aqarraallemteńi caullrua?",
        "translation": "When did we first move here again?"
    },
    "9": {
        "startTime": 56.378,
        "endTime": 59.568,
        "transcript": "Nineteen-sixty-nine maani.",
        "translation": "Nineteen-sixty-nine here."
    },
    "10": {
        "startTime": 59.572,
        "endTime": 61.552,
        "transcript": "Tuyuurrlua tua-i.",
        "translation": "I became a pastor."
    },
    "11": {
        "startTime": 64.606,
        "endTime": 71.995,
        "transcript": "Lay pastor-aaruluten im'un, reverend...",
        "translation": "As a lay pastor, your, you know, reverend..."
    },
    "12": {
        "startTime": 74.611,
        "endTime": 78.982,
        "transcript": "Kitak' Nanvarnarrlagmek murilkellerpeni",
        "translation": "Now, with your observation of Nanvarnarrlak"
    },
    "13": {
        "startTime": 78.992,
        "endTime": 87.672,
        "transcript": "Qaillun taukut Nanvarnarrlagmiut ayuqucillratnek murilkestellren tangerrluku qanemcitqerkut.",
        "translation": "Tell us a story about what the people of Nanvarnarrlak was like looking at your guardian."
    },
    "14": {
        "startTime": 90.299,
        "endTime": 93.839,
        "transcript": "Arulaiqsaileng'e'rma-qaa? (Ii-i, arulaqsaileng'e'rpet.)",
        "translation": "Without stopping? (Yes, without stopping.)"
    },
    "15": {
        "startTime": 93.847,
        "endTime": 95.757,
        "transcript": "Waniwa-qaa ayagnirlua? (Ii-i.)",
        "translation": "Do I start now? (Yes.)"
    },
    "16": {
        "startTime": 95.759,
        "endTime": 98.469,
        "transcript": "Yaa, quyana. Umyugiuqatalliniunga.",
        "translation": "Okay, thank you. So, I'll do what I want."
    },
    "17": {
        "startTime": 98.477,
        "endTime": 100.097,
        "transcript": "Yaa, umyugiuqatartuten.",
        "translation": "Yes, you'll do what you want."
    },
    "18": {
        "startTime": 103.248,
        "endTime": 114.926,
        "transcript": "Nanvarnarrlagmi tayima tau͡gaam allrakuq apqerciiganaku ayagyuaqapiarlua tamatum nalliini",
        "translation": "In Nanvarnarrlak, but I can't say what year when I was very young at that time"
    },
    "19": {
        "startTime": 115.828,
        "endTime": 121.358,
        "transcript": "Elitnauraunrilama-llu tangvagluki tau͡gaam elitellrulrianga",
        "translation": "And since I wasn't a student, I only learned by watching them"
    },
    "20": {
        "startTime": 121.362,
        "endTime": 128.052,
        "transcript": "Au͡g'umek tuyungellemteńi Neck, Uyaquq.",
        "translation": "When we got that pastor, Neck, Uyaquq [in Yup'ik]."
    },
    "21": {
        "startTime": 128.736,
        "endTime": 131.216,
        "transcript": "Lloyd Nick-auluni.",
        "translation": "He was Lloyd Nick."
    },
    "22": {
        "startTime": 134.512,
        "endTime": 144.142,
        "transcript": "Nanvarnarrlagmi agayullrani tangvakarraallruaqa enemi.",
        "translation": "I first saw him preaching in Nanvarnarrlak in a house."
    },
    "23": {
        "startTime": 145.789,
        "endTime": 151.059,
        "transcript": "Kinguakun tau͡gaam qasgimi tangvagaqluku agayuaqan.",
        "translation": "But afterwards, I'd watch him preach in the community house."
    },
    "24": {
        "startTime": 151.097,
        "endTime": 156.747,
        "transcript": "Yuut quyurrluteng. Kuluk'uunailameng kelegtuuriluteng.",
        "translation": "People would gather. Since they had no bell, they'd [personally] invite people."
    },
    "25": {
        "startTime": 157.008,
        "endTime": 161.538,
        "transcript": "Piyugngalriit nunanek quyurciaqluteng.",
        "translation": "Those who were able would gather people from villages."
    },
    "26": {
        "startTime": 164.273,
        "endTime": 167.083,
        "transcript": "Uyaquq-llu igamikun...",
        "translation": "And with Uyaquq's orthography..."
    },
    "27": {
        "startTime": 168.673,
        "endTime": 171.493,
        "transcript": "Tangerqercecugyaaqvaa-lli.",
        "translation": "How I wish I could show you."
    },
    "28": {
        "startTime": 171.729,
        "endTime": 179.989,
        "transcript": "Uyaquq igamikun Bible-aanek naaqiaqluni.",
        "translation": "Uyaquq would read the Bible in his own orthography."
    },
    "29": {
        "startTime": 180.974,
        "endTime": 187.587,
        "transcript": "Wiinga-wa niiteqarraalqa Bible-aamek, ciuqliinani-ll'",
        "translation": "That was the first I heard of the Bible, and there was no one before him."
    },
    "30": {
        "startTime": 187.591,
        "endTime": 195.581,
        "transcript": "Au͡gkut-llu wiinga anglicartenka maurlurluunka-llu Bible-aarunateng.",
        "translation": "And those who raised and my grandmothers had no Bibles."
    },
    "31": {
        "startTime": 195.594,
        "endTime": 199.594,
        "transcript": "Bible-aamek-llu naaqilriamek niiteksaunii.",
        "translation": "And I hadn't heard anyone reading the Bible."
    },
    "32": {
        "startTime": 206.305,
        "endTime": 214.535,
        "transcript": "Ciungani naaqivkarluku tangerpailemku unugmi elitnauraa tekitelliniluni.",
        "translation": "Before I saw him reading, his pupil arrived at night."
    },
    "33": {
        "startTime": 214.717,
        "endTime": 224.057,
        "transcript": "Maurlurluma-am ukatmun ella maliggluku uivelaasqelluk' qanemcikarcurlua-gguq.",
        "translation": "My grandmother told me to turn clockwise this way in what she called looking for a story [forecast]."
    },
    "34": {
        "startTime": 224.274,
        "endTime": 230.024,
        "transcript": "Ella tangelqa qanemciksarturluku, qanemcikarkauluku elliinun.",
        "translation": "I would have to go tell her about the weather that I saw."
    },
    "35": {
        "startTime": 230.031,
        "endTime": 235.031,
        "transcript": "Naken-llu waniw' anuqliucia nallusqevkenaku.",
        "translation": "And she told me to know where the wind was blowing from."
    },
    "36": {
        "startTime": 237.298,
        "endTime": 242.898,
        "transcript": "Maaten waniw' tua-i cukangnaqlua qanertua",
        "translation": "When I was in a hurry, I said"
    },
    "37": {
        "startTime": 246.791,
        "endTime": 252.611,
        "transcript": "\"Anngama ukatmun waten kiarqu'rtua tallirpima tungiinun.",
        "translation": "\"When I went out, I looked out to the right like this."
    },
    "38": {
        "startTime": 254.295,
        "endTime": 263.385,
        "transcript": "\"Tua-i-ll' kuigem tunglirnera tangrraqa pelatekacuartanga'artellinilria unugmi.",
        "translation": "\"Then when I looked toward the river, and there was a small tent at night."
    },
    "39": {
        "startTime": 263.391,
        "endTime": 266.141,
        "transcript": "\"Malrugnek tevvnerluni.\"",
        "translation": "\"It had two drapes.\""
    },
    "40": {
        "startTime": 266.736,
        "endTime": 276.066,
        "transcript": "Wiinga-ll' tua-i kamilangqiima niugtenritua tayim' atrallemni pelatekacuaraam amiiga tangerrsarturluku.",
        "translation": "Then since I was barefoot, I didn't make a sound as I went down to see the small tent's entrance."
    },
    "41": {
        "startTime": 276.27,
        "endTime": 282.42,
        "transcript": "Igvaryaaqaqa kipullgusngaluni waten patumaluni.",
        "translation": "When it came into my view, it was closed, the flaps crossing like this."
    },
    "42": {
        "startTime": 285.009,
        "endTime": 291.029,
        "transcript": "Tua-i-ll' tangvakanemkun ciuqerranun nangerrlua yaaqvaariluku.",
        "translation": "Then right when I saw it, I stood in front of it from a distance."
    },
    "43": {
        "startTime": 297.317,
        "endTime": 304.517,
        "transcript": "Uitaqanemkun qamna waten ayagnirtuq, nutaan-llu wii Bible-aamek niillua:",
        "translation": "When I stood still, the person inside started like this, and it was the first time I heard the Bible:"
    },
    "44": {
        "startTime": 305.246,
        "endTime": 313.226,
        "transcript": "\"Ataneq qigcikellra elisngamun ayagniutnguarkauguq.",
        "translation": "\"Respect for the Lord will be the beginning of knowledge."
    },
    "45": {
        "startTime": 313.232,
        "endTime": 322.192,
        "transcript": "\"Tau͡gaam ellakenrilnguut cakenritaat elisnganeq ayuqucirtuun-llu.",
        "translation": "\"But those without sense do not care for knowledge and teaching."
    },
    "46": {
        "startTime": 322.401,
        "endTime": 328.561,
        "transcript": "\"Yum'a, niiskiu atavet ayuqucirtuutii",
        "translation": "\"My child, obey your father's instruction"
    },
    "47": {
        "startTime": 328.607,
        "endTime": 333.927,
        "transcript": "\"Aanavet-llu picirkiutii unicaqunaku",
        "translation": "\"And do not leave your mother's command"
    },
    "48": {
        "startTime": 334.261,
        "endTime": 345.861,
        "transcript": "\"Alngauciqngameng qamiqurpenun ilukegcinarqelriamek, uyamiuciqngameng-llu uyaqerpegun.\"",
        "translation": "\"Because they will be writing in your head that will bring you joy, and they will be a necklace around your neck.\""
    },
    "49": {
        "startTime": 346.448,
        "endTime": 356.125,
        "transcript": "Agayulirteńgurteqanemkun nalaqaqa Proverbs chapter 1, verses 7-9.",
        "translation": "As soon as I became a priest, I found it in Proverbs chapter 1, verses 7-9."
    },
    "50": {
        "startTime": 356.129,
        "endTime": 361.629,
        "transcript": "Tuantellinilria au͡gna niitelqa.",
        "translation": "What I'd heard was there."
    },
    "51": {
        "startTime": 362.438,
        "endTime": 368.288,
        "transcript": "Tua-i-ll' taqngan qama-i aqvaqurtua utqerrlua.",
        "translation": "Then when he was done in there, I ran right home."
    },
    "52": {
        "startTime": 368.359,
        "endTime": 374.939,
        "transcript": "Kamilangqiima niugtenritua. Tang niitenricugnarqaanga-llu taum.",
        "translation": "Since I was barefoot, I didn't make a sound. You see, he probably didn't hear me."
    },
    "53": {
        "startTime": 375.328,
        "endTime": 387.52,
        "transcript": "Enevut-llu tua-i kitu'urrluku tumyaratgun tagqercama ilutuuralriamun tekicama arulairtua.",
        "translation": "And when I went inland through the path past our house, I stopped when I reached a deeper area."
    },
    "54": {
        "startTime": 387.533,
        "endTime": 393.563,
        "transcript": "\"Atak' imna naspaaqerlaku camani niitelqa.\"",
        "translation": "\"Well now, let me try what I heard down there.\""
    },
    "55": {
        "startTime": 397.069,
        "endTime": 404.999,
        "transcript": "Nunapik caugarrluku, qungut-wa pia-i alaunateng, caugarrluku naspaagaqa.",
        "translation": "I faced the tundra, while the graves inland were visible, I faced it and tried it."
    },
    "56": {
        "startTime": 405.244,
        "endTime": 411.074,
        "transcript": "\"Ataneq qigcikellra elisngamun ayagniutnguarkauguq.",
        "translation": "\"Respect for the Lord will be the beginning of knowledge."
    },
    "57": {
        "startTime": 411.122,
        "endTime": 418.202,
        "transcript": "\"Tau͡gaam ellakenrilnguut cakenritaat elisnganeq ayuqucirtuun-llu.",
        "translation": "\"But those without sense do not care for knowledge and teaching."
    },
    "58": {
        "startTime": 418.554,
        "endTime": 423.664,
        "transcript": "\"Yum'a, niiskiu atavet ayuqucirtuutii",
        "translation": "\"My child, obey your father's instruction"
    },
    "59": {
        "startTime": 423.671,
        "endTime": 428.531,
        "transcript": "\"Aanavet-llu picirkiutii unicaqunaku",
        "translation": "\"And do not leave your mother's command"
    },
    "60": {
        "startTime": 428.671,
        "endTime": 439.571,
        "transcript": "\"Alngauciqngameng qamiqurpenun ilukegcinarqelriamek, uyamiuciqngameng-llu uyaqerpenun.\"",
        "translation": "\"Because they will be writing in your head that will bring you joy, and they will be a necklace around your neck.\""
    },
    "61": {
        "startTime": 440.47,
        "endTime": 455.77,
        "transcript": "Waniwa tua-i Bible-aaq tauna elitellrulliniaqa tuani ellami amiigmi, amiik tangvagluku qamna qalartellria niiqurluku.",
        "translation": "I apparently learned the Bible outside by that door, watching that door and listening to the person inside."
    },
    "62": {
        "startTime": 456.323,
        "endTime": 462.611,
        "transcript": "Nalluyagutesciigataqa waniw' unguvallemni maa-i.",
        "translation": "I can't forget it as I'm alive here."
    },
    "63": {
        "startTime": 463.264,
        "endTime": 471.626,
        "transcript": "Cali-ll' nalaqellruamku Proverbs chapter 1, verses 7-9.",
        "translation": "Also because I found it in Proverbs chapter 1, verses 7-9."
    },
    "64": {
        "startTime": 471.644,
        "endTime": 477.107,
        "transcript": "Tuani cali kalikaunaku elitellruluku nalaqutaqa.",
        "translation": "I also learned what I [later] found without paper."
    },
    "65": {
        "startTime": 480.656,
        "endTime": 492.019,
        "transcript": "Waniwa ava-i amllerni allrakuni calligtaarlua agayulirteńgurcama pivkaqiitnga.",
        "translation": "Now, when I became a priest, they had me move a lot over many years."
    },
    "66": {
        "startTime": 492.024,
        "endTime": 498.362,
        "transcript": "Ciungani tuyuulua cali ayagcetaulua pivkarlua.",
        "translation": "Before that, they'd also sent me as a pastor."
    },
    "67": {
        "startTime": 498.363,
        "endTime": 509.688,
        "transcript": "Au͡gna tau͡gaam ataucirquunrilngurmek qaneryaraqluku pilallruunga eliteqarraarvikellruamku.",
        "translation": "But I would use that verse more than once because it was the first one I learned."
    },
    "68": {
        "startTime": 511.594,
        "endTime": 518.781,
        "transcript": "Pektesteḿek tangerqarraalqa Akiarmiumek Robert-aaruluni.",
        "translation": "The first [?pektesta] I saw was Robert from Akiak."
    },
    "69": {
        "startTime": 518.794,
        "endTime": 524.281,
        "transcript": "Yugtun-am atra nalluqaraqa tayima. Nallunritellruyaaqaqa.",
        "translation": "I forgot his Yup'ik name. I did know it."
    },
    "70": {
        "startTime": 524.351,
        "endTime": 537.288,
        "transcript": "Tekilluni atama kelegniluku Uyaqum eniini uitallrani neryartuusqelluku.",
        "translation": "He arrived, saying that my father invited him to eat when he was at Uyaquq's house."
    },
    "71": {
        "startTime": 539.296,
        "endTime": 547.083,
        "transcript": "Puciinaaq, Puciinaaq qanertuq qantuami-llu, elliin-gguq maligciiqaa.",
        "translation": "Puciinaaq, Puciinaaq said because [s]he speaks up that [s]he will go with him."
    },
    "72": {
        "startTime": 547.993,
        "endTime": 558.018,
        "transcript": "Tua-ll' atama piyaaqaa, \"Tun'ernarqeciquten nerkan. Qassayaarturcetqata'arqa.\"",
        "translation": "Then my father said to him, \"You'll be embarrassing when he eats. I'm going to have him eat frozen aged whitefish.\""
    },
    "73": {
        "startTime": 560.415,
        "endTime": 572.127,
        "transcript": "Tua-i-ll' Aalaaq tauna ungaulugtuq. Maliguciiquq-gguq. Tangerrsugaa-gguq enevut.",
        "translation": "Then Aalaaq shook his head. He said he'll follow. He said he wants to see our house."
    },
    "74": {
        "startTime": 574.018,
        "endTime": 582.356,
        "transcript": "Enepiaruluni nunamek ciuqlirnek enengqellruamta wangkuta, laavkaartaunani.",
        "translation": "It was a sod house from the land sicne we had the first houses, with no wooden houses."
    },
    "75": {
        "startTime": 584.038,
        "endTime": 587.938,
        "transcript": "Tua-i-llu iterluni aqumluni.",
        "translation": "Then he came in and sat down."
    },
    "76": {
        "startTime": 590.416,
        "endTime": 597.703,
        "transcript": "Kiatiinun nerellrani qanengssagaluni Yugtun qantuami Puciinaaq.",
        "translation": "Then when he ate further in from him, he was speaking because Puciinaaq spoke Yup'ik."
    },
    "77": {
        "startTime": 598.109,
        "endTime": 604.134,
        "transcript": "Arturngaunani qanllerkaminek, Yugtun pillerkaminek.",
        "translation": "He could manage to speak, speak in Yup'ik."
    },
    "78": {
        "startTime": 605.63,
        "endTime": 618.164,
        "transcript": "Tua-i-llu yuurqanermek taqngami Robert-aaq nererraarluni",
        "translation": "Then when he was done drinking something ate after Robert ate"
    },
    "79": {
        "startTime": 618.424,
        "endTime": 631.512,
        "transcript": "Taqngami kalikivini teguluku ikirtaa qanerluni, \"Elitnauqataramken.\"",
        "translation": "When he was done, he took and opened his book bag and said, \"I'm going to teach you.\""
    },
    "80": {
        "startTime": 634.729,
        "endTime": 649.904,
        "transcript": "Chapter-aara aperturpek'naku Paaskaarcuutet tegumiaqluki ikirtai. Elliin tangvagluki, wii tau͡gken tangvagpek'naku.",
        "translation": "Without mentioning the chapter, he held and opened the book used for Easter. He was looking at, but I wasn't looking at it."
    },
    "81": {
        "startTime": 650.316,
        "endTime": 661.666,
        "transcript": "Tua-i-llu qanerluni, waniwa-gguq elitnauqataraanga nalluyagutarkaqenrilkemnek.",
        "translation": "Then he said that he's now going to teach me something that I shouldn't forget."
    },
    "82": {
        "startTime": 661.686,
        "endTime": 667.198,
        "transcript": "Nangertesqellua-llu. Nangerrlua-llu tua-i caugarrluku.",
        "translation": "And he told me to stand. So I stood and faced him."
    },
    "83": {
        "startTime": 667.2,
        "endTime": 676.125,
        "transcript": "Tan'gaurlullraulua tangelqa nalluyagucuunaku tau͡gaam.",
        "translation": "But, I'd never forgotten what I'd seen as a little boy."
    },
    "84": {
        "startTime": 676.441,
        "endTime": 683.929,
        "transcript": "Tua-i-ll' ikna, waniwa-gguq ayagniqatartuq elitnaurlua.",
        "translation": "Then across there, he said that he's now going to begin teaching me."
    },
    "85": {
        "startTime": 685.135,
        "endTime": 689.797,
        "transcript": "Chapter-aara verse-aara-llu aperturpek'naku.",
        "translation": "He didn't mention the chapter and verse."
    },
    "86": {
        "startTime": 691.352,
        "endTime": 694.24,
        "transcript": "Tua-i-ll' ayagnirlun' waten:",
        "translation": "Then he started like this:"
    },
    "87": {
        "startTime": 695.177,
        "endTime": 706.94,
        "transcript": "\"Yiissussaaq-llu qayagaluni qanertuq, 'Wangnun ukvelria wangnun pivkenani, ayagtestemnun ukvertuq.",
        "translation": "\"Jesus proclaimed, \"One who believes in me does not believe in me, but to the one who sent me."
    },
    "88": {
        "startTime": 706.974,
        "endTime": 712.136,
        "transcript": "\"'Wangnek-llu tangellriim aata tangraa.",
        "translation": "\"'And one who sees me sees the father."
    },
    "89": {
        "startTime": 712.148,
        "endTime": 720.873,
        "transcript": "\"'Tanqiulua nunamun tekitua wangnun ukvelria tan'geremtesqevkenaku.",
        "translation": "\"'I came to this land as a light so that one who believes in me will not be in darkness."
    },
    "90": {
        "startTime": 720.876,
        "endTime": 730.388,
        "transcript": "\"'Qaneryaramnek-llu niitellria ukvekevkenaki-llu, tauna qanercetaartekangqertuq.",
        "translation": "\"'And one who hears my word and does not believe then, [s]he will be tried."
    },
    "91": {
        "startTime": 730.408,
        "endTime": 738.233,
        "transcript": "\"'Qaneryaram qanercetaarciqaa ernermi nangneqlirmi.",
        "translation": "\"'The word will try that person in the last day."
    },
    "92": {
        "startTime": 738.238,
        "endTime": 746.463,
        "transcript": "\"'Taumek qallataqama tuaten qallatelartua atamnun qanruyucimtun.'\"",
        "translation": "\"'That's why when I speak, I speak like that as my father told me to.'\""
    },
    "93": {
        "startTime": 746.868,
        "endTime": 750.793,
        "transcript": "Nangluni-ll' tua-i waniwa elitnaurutii.",
        "translation": "And that was end of his lesson."
    },
    "94": {
        "startTime": 750.802,
        "endTime": 756.352,
        "transcript": "Taktaciatun elitellrulliniluku.",
        "translation": "I learned all of it."
    },
    "95": {
        "startTime": 756.511,
        "endTime": 761.561,
        "transcript": "Kalikaunii agayuyugngarilua.",
        "translation": "I became able to preach without a paper."
    },
    "96": {
        "startTime": 761.569,
        "endTime": 769.519,
        "transcript": "Yuarutmek-llu eliteqarraartua Uyaqurtarteggun igaumaluteng.",
        "translation": "And I first learned a song written in Uyaquq's orthography."
    },
    "97": {
        "startTime": 769.524,
        "endTime": 779.999,
        "transcript": "Waten aperyarangqerrluni, cali elitnaunrilengraatnga elitellruluku niicugniurluku:",
        "translation": "These were the words, and without them teaching me, I learned it by listening:"
    },
    "98": {
        "startTime": 780.1,
        "endTime": 791.925,
        "transcript": "\"Quyanaqvaa elpeni, quyalartut pakmani",
        "translation": "\"We are thankful for you, they are thankful [in Heaven] up there"
    },
    "99": {
        "startTime": 791.946,
        "endTime": 804.134,
        "transcript": "\"Camek artuqailavet, naklegtaavet-llu elpet.\"",
        "translation": "\"Because you can manage anything, and because you are compassionate.\""
    },
    "100": {
        "startTime": 804.147,
        "endTime": 808.66,
        "transcript": "Cunaw' tua-i igat elilluki tuani.",
        "translation": "Apparently, I'd learned the writing then."
    },
    "101": {
        "startTime": 808.667,
        "endTime": 812.73,
        "transcript": "Naaqiturilua makunek Paaskaarcuutnek.",
        "translation": "I started reading this book used for Easter."
    },
    "102": {
        "startTime": 812.74,
        "endTime": 822.328,
        "transcript": "Elliin-llu cali Uyaqum igai elilluki, naaqeturiluki tuaten.",
        "translation": "I also learned Uyaquq's orthography, and could even read them."
    },
    "103": {
        "startTime": 826.563,
        "endTime": 835.751,
        "transcript": "Cunaw' agayulirteńgureskuma caliarkanka makut kalikaunii piyugngarilua.",
        "translation": "It turned out that when I would become a priest, I could do my work without papers."
    },
    "104": {
        "startTime": 838.339,
        "endTime": 845.651,
        "transcript": "Uyaquq-llam igalliniuq ellii urenkutmek qanerluni waten:",
        "translation": "Uyaquq wrote an intention saying this:"
    },
    "105": {
        "startTime": 845.664,
        "endTime": 855.702,
        "transcript": "\"Agayun qanellruuq, 'Alarcaqunak. Niicugnikina ciutegken angparrlukek.",
        "translation": "\"God said, 'Do not falter. Open your ears and listen."
    },
    "106": {
        "startTime": 855.715,
        "endTime": 860.69,
        "transcript": "\"'Ca tamarmi pakmaken kingunengqertuq.",
        "translation": "\"'Everything comes from above."
    },
    "107": {
        "startTime": 860.988,
        "endTime": 869.613,
        "transcript": "\"'Ciiskayuggaunge'rmi-llu nunami pakmaken tuaten taqumauq.",
        "translation": "\"'Even a tiny insect on the land is created from above."
    },
    "108": {
        "startTime": 869.634,
        "endTime": 877.734,
        "transcript": "\"'Agayumalria, pegnem qanraqluten, pegnem-llu qenqertaqluten.",
        "translation": "\"'Oh Christian, be slow to speak, and be slow to anger."
    },
    "109": {
        "startTime": 877.748,
        "endTime": 885.736,
        "transcript": "\"'Qaneryararkaten pingayurqunek ciumek elpet naspaarraaqiki.",
        "translation": "\"'First, test what you are going to say three times."
    },
    "110": {
        "startTime": 885.74,
        "endTime": 891.428,
        "transcript": "\"'Yuum cangayuutekarkaunrilkaki anetniaten.'\"",
        "translation": "\"'If a person will not take offense from them, speak them.\""
    },
    "111": {
        "startTime": 891.587,
        "endTime": 895.587,
        "transcript": "Ukut waniwa kalikaunii.",
        "translation": "I [learned] these without paper."
    },
    "112": {
        "startTime": 897.496,
        "endTime": 907.796,
        "transcript": "Elitnaullrunricaaqlua tau͡gaam atanrem waten pitalriamek elitevkaraanga kalikaunii.",
        "translation": "I wasn't a student, but the Lord had me learn this much without papers."
    },
    "113": {
        "startTime": 909.584,
        "endTime": 921.534,
        "transcript": "Yuarutem au͡g'um makut mumigtallrit Moravian-aat elitevkarai, naaqetuvkarluki tuaten.",
        "translation": "He let me learn that song, these [songs] that the Moravians translated, and even let me learn them."
    },
    "114": {
        "startTime": 922.9,
        "endTime": 937.891,
        "transcript": "Cali-llam emusngallemni hospital-aami Catholic-aat Bible-aaritnek, Revelation-aaritnek naaqiunga.",
        "translation": "Also, when I was getting checked at the hospital, I read the Catholic Bible, their Revelations."
    },
    "115": {
        "startTime": 941.08,
        "endTime": 948.405,
        "transcript": "Makutgun qanrutkelallritgun nutaratgun igaumaluteng tamakut.",
        "translation": "Those were written in the new orthography that they spoke of."
    },
    "116": {
        "startTime": 948.859,
        "endTime": 960.534,
        "transcript": "Cunaw' tua-i tangrramki maa-i-llu makut kinguqliit mumigcilriit igaqngatki naaqetuluki tuaten.",
        "translation": "It turned out that when I saw them, because they were written by the next generation of translators, I would also read them."
    },
    "117": {
        "startTime": 960.542,
        "endTime": 967.529,
        "transcript": "Maa-i tuani elitellrulliniluki Revelation-aanek naaqillemni.",
        "translation": "I learned [how to read] them when I read Revelations."
    },
    "118": {
        "startTime": 968.622,
        "endTime": 981.684,
        "transcript": "Catholic-aartarteggun igaumalriit elilluki. Maa-i-ll' nutaraurcata alangaarpek'nii naaqetuluki tamakut.",
        "translation": "I learned the ones written by the Catholics. And since it's updated now, I wasn't shocked, but could read them."
    },
    "119": {
        "startTime": 983.339,
        "endTime": 986.664,
        "transcript": "Tuani tua-i elitellrulliniamki.",
        "translation": "Because I learned them then."
    },
    "120": {
        "startTime": 987.181,
        "endTime": 998.231,
        "transcript": "Man'a cunaw' caliarkaqa pitekluku atanrem waten makunek pinarqelrianek pillinikiinga.",
        "translation": "It turned out that the Lord had me [learn] these things I needed to for my work."
    },
    "121": {
        "startTime": 998.377,
        "endTime": 1010.74,
        "transcript": "Waniwa ciuqlirteggun au͡gkut ciuqliit cimirpailgatki kalikaqlemteńi",
        "translation": "Now, when we had the first books before the changed the first ones"
    },
    "122": {
        "startTime": 1011.028,
        "endTime": 1021.29,
        "transcript": "Kalikaunii-llu angllurceciyartua augturceciyarlua-llu tamakut aturluki ciuqliit.",
        "translation": "Without any books, I would go baptize and lead communions using those first ones."
    },
    "123": {
        "startTime": 1021.572,
        "endTime": 1029.96,
        "transcript": "Waniwa tua-i piyugngayaaqengramki kinguqlirteggun tau͡gaam maa-i naaqeturiluki.",
        "translation": "Though I can recite them now, I started reading from the later ones."
    },
    "124": {
        "startTime": 1032.017,
        "endTime": 1039.565,
        "transcript": "Man'a piuralqa quyatekaqa.",
        "translation": "I'm thankful for all I did."
    },
    "125": {
        "startTime": 1040.002,
        "endTime": 1050.314,
        "transcript": "Cali-llu nalluqapiaryalrianga tuntulgurrlua qiayugngalua.",
        "translation": "Also, I would know nothing, being able to cry having become a reindeer herder."
    },
    "126": {
        "startTime": 1050.329,
        "endTime": 1056.629,
        "transcript": "Tuntulgurrnilua miluqutamek ac'etaatnga maavet elliluku.",
        "translation": "They said I was now a reindeer herder and had me put on a brand here."
    },
    "127": {
        "startTime": 1057.311,
        "endTime": 1062.299,
        "transcript": "Miluqutaq atanerruam ac'ecamiu waten qanertuq:",
        "translation": "When the lower authority put the brand on me, he said this:"
    },
    "128": {
        "startTime": 1062.308,
        "endTime": 1070.62,
        "transcript": "\"Man'a ayallren tamalkuan miluqutaq ayauskiu. Neqnguuq.\"",
        "translation": "\"Everywhere you go, take this brand with you. It's a fish.\""
    },
    "129": {
        "startTime": 1070.919,
        "endTime": 1073.069,
        "transcript": "Cauga tauna miluqutaq?",
        "translation": "What's a miluqutaq?"
    },
    "130": {
        "startTime": 1073.077,
        "endTime": 1077.965,
        "transcript": "Ilavkuk tuntuliurcuun.",
        "translation": "A rope for reindeer herding."
    },
    "131": {
        "startTime": 1080.209,
        "endTime": 1090.546,
        "transcript": "Tuntut tegukunegteggu milqerluku maagarkauluku kitumun pikucia nallunrirtelluku.",
        "translation": "When they take reindeer, they would brand it with a mark to indicate who it belongs to."
    },
    "132": {
        "startTime": 1091.612,
        "endTime": 1100.95,
        "transcript": "Elitaqillerkarpeciuggun atauciq aperturnaurqa.",
        "translation": "So that you will recognize it, let me say one thing."
    },
    "133": {
        "startTime": 1100.968,
        "endTime": 1113.256,
        "transcript": "Moravian-aat maangqellruut tuntum ciutiek kangriqerlukek yaaqvani teriiqan elitaqarkauluku.",
        "translation": "The moravians had a mark by removed the tips of reindeer ears so that they would recognize it if it acts strangley from afar."
    },
    "134": {
        "startTime": 1114.679,
        "endTime": 1121.304,
        "transcript": "Wiinga-llu maagmek cali cikirlua elitarkamnek.",
        "translation": "They also gave me a mark for me to learn."
    },
    "135": {
        "startTime": 1122.678,
        "endTime": 1125.816,
        "transcript": "Nalluyagucetevkenaku.",
        "translation": "They didn't let me forget it."
    },
    "136": {
        "startTime": 1126.375,
        "endTime": 1133.437,
        "transcript": "Tuamta-llu nuussimek naqugutmek pianga wavet agarrluku.",
        "translation": "Then a knife, he gave me a belt and hung it here."
    },
    "137": {
        "startTime": 1134.222,
        "endTime": 1141.472,
        "transcript": "Tamana naqugun amiuguq qillernertarluni.",
        "translation": "That belt was made of hide and had straps to tie it with."
    },
    "138": {
        "startTime": 1141.53,
        "endTime": 1148.455,
        "transcript": "Qukaqa-ll' tua-i cuqluku taum ac'etesteḿa.",
        "translation": "Then the one who put it on my measured my waist."
    },
    "139": {
        "startTime": 1148.465,
        "endTime": 1152.078,
        "transcript": "Waniwa-gguq qukama pitacia.",
        "translation": "He told me my waist length."
    },
    "140": {
        "startTime": 1152.09,
        "endTime": 1162.478,
        "transcript": "Una-gguq waniwa pirciqan-llu wall'u ellarayauskanga naqugutaq-gguq aturluku tarritarkaugua.",
        "translation": "He said that if a blizzard sets or the weather turns bad on me, that I must travel wearing the belt."
    },
    "141": {
        "startTime": 1162.675,
        "endTime": 1171.913,
        "transcript": "Pirciqan-llu maaggun ilumkun pirtuum iterngaunii. Tuaten piarkaulua.",
        "translation": "And if there's a blizzard, the blowing snow wouldn't go in my [clothes] here. I would have to do that."
    },
    "142": {
        "startTime": 1172.193,
        "endTime": 1186.943,
        "transcript": "Tuamta-llu tamana pegcamiu naqugun, nuussiq wavet ellillerminiu waten qanertuq:",
        "translation": "Then when he let go of that belt, he said this when he put the knife here:"
    },
    "143": {
        "startTime": 1187.036,
        "endTime": 1191.736,
        "transcript": "\"Ayallren tamalkuan ayautelaqiu.",
        "translation": "\"Take it everywhere you go."
    },
    "144": {
        "startTime": 1191.767,
        "endTime": 1200.242,
        "transcript": "\"Nani unilluku ayakuvet, nalluyagulluku ayakuvet",
        "translation": "\"If you leave it somewhere and go, if you forget it and go"
    },
    "145": {
        "startTime": 1203.982,
        "endTime": 1215.207,
        "transcript": "\"Imkurciquq, arenqiallugciiquten, curulugkartessuutaunak-llu piarkauluten.\"",
        "translation": "\"It will, you know, you will have misfortune, and have nothing to gather grass for matting.\""
    },
    "146": {
        "startTime": 1215.423,
        "endTime": 1224.11,
        "transcript": "Tua-i-llu ayauqurluki taukut pingayun pik'nganka.",
        "translation": "Then I would always bring those three things that I owned."
    },
    "147": {
        "startTime": 1224.254,
        "endTime": 1234.667,
        "transcript": "Taumek maa-i tunciullrunrilkuma Agayutem qusngii auluklemni ayuquciicartua.",
        "translation": "That's why had I not herded reindeer, I would be lost when taking care of God's sheep."
    },
    "148": {
        "startTime": 1234.686,
        "endTime": 1241.411,
        "transcript": "Tamaani elitellrulliniunga Agayutem qusngiinek aulukillerkamnek.",
        "translation": "Back then, I apparently learned how I could take care of God's sheep."
    },
    "149": {
        "startTime": 1241.437,
        "endTime": 1247.325,
        "transcript": "Atanerruam inerquraanga; nangenruluku waniw' qanernaurtua",
        "translation": "The lower authority admonished; let me say this last thing"
    },
    "150": {
        "startTime": 1248.846,
        "endTime": 1255.633,
        "transcript": "Tuntu-gguq akngirrngaitaqa. Yungqertuq-gguq.",
        "translation": "He said I shouldn't hurt the reindeer. He said it has a spirit."
    },
    "151": {
        "startTime": 1256.423,
        "endTime": 1266.186,
        "transcript": "Wall'u nutegluku piarkauvkenaku, wall'u qaill' piluku akngirrluku piarkauvkenaku.",
        "translation": "Or, I should not shoot it, or I should not somehow hurt it."
    },
    "152": {
        "startTime": 1266.517,
        "endTime": 1272.954,
        "transcript": "Yungqertuq-gguq. Yuan-gguq tangvagaanga, tangvagciqaanga.",
        "translation": "He said it has a spirit. He said it's spirit is watching me, will watch me."
    },
    "153": {
        "startTime": 1272.964,
        "endTime": 1279.814,
        "transcript": "Tua-i cunaw' Agayutem auluklemteńi tamana umyuaqaqa.",
        "translation": "It turned out that when we took care of God's sheep, I remembered that."
    },
    "154": {
        "startTime": 1280.691,
        "endTime": 1288.903,
        "transcript": "Qigcikluki tuaten, piciatun-llu qalarutlerkaat alinguqluku piaqlua",
        "translation": "I eve respected them, and feared speaking to them wrong"
    },
    "155": {
        "startTime": 1289.062,
        "endTime": 1293.837,
        "transcript": "Yungqelliniata Agayutem qusngii.",
        "translation": "Because God's sheep have spirits."
    },
    "156": {
        "startTime": 1295.851,
        "endTime": 1300.738,
        "transcript": "I think it's gotten long, so this is all I want to say.",
        "translation": "I think it's gotten long, so this is all I want to say."
    },
    "157": {
        "startTime": 1300.757,
        "endTime": 1302.882,
        "transcript": "Ii-i, yaa.",
        "translation": "Yes, okay."
    },
    "158": {
        "startTime": 1303.588,
        "endTime": 1313.138,
        "transcript": "Amllermi niicugnikuvcia ikayuutnguciquq elpeceńun ayagyuaqapiarlua pillruama.",
        "translation": "Many times, if you listen to me, it will be beneficial to you since I did it when I was very young."
    },
    "159": {
        "startTime": 1313.27,
        "endTime": 1321.595,
        "transcript": "Makut nalluyagutevkenaki nalluvkenaki tau͡gaam atullruanka.",
        "translation": "I experienced these without forgetting them, but knowing them."
    },
    "160": {
        "startTime": 1321.954,
        "endTime": 1324.504,
        "transcript": "Quyanaqvaa. (Yaa, quyana.)",
        "translation": "Thank you very much. (Yes, thank you.)"
    },
    "161": {
        "startTime": 1326.276,
        "endTime": 1338.238,
        "transcript": "Au͡gna-qaa tauna Uyaquq niiteqarraallerpegu au͡gkunek Proverbs-aanek qavcirngatellrullinisit tamaani?",
        "translation": "Back when you heard Uyaquq reading Proverbs, how old did you seem back then?"
    },
    "162": {
        "startTime": 1339.611,
        "endTime": 1345.636,
        "transcript": "Wiinga tuntumun nangertellemni qiallruunga.",
        "translation": "When I stood to the reindeer, I cried."
    }
};